import React from "react";
import EmployeeSalaryPaymentListTable from "./components/EmployeeSalaryPaymentListTable";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const EmployeeSalaryPaymentList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={<HeadingOne>Employee Salary Payment List</HeadingOne>}
        >
            <div className="col-12">
                <EmployeeSalaryPaymentListTable />
            </div>
        </PageBody>
    );
};

export default EmployeeSalaryPaymentList;
